import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { MarketplaceGate } from "@/components/marketplace/gate";
import { MarketplaceServiceCard } from "@/components/marketplace/service-card";
import { isFeatured } from "@/lib/marketplace/promotions";
import { fetchMarketplaceCategories, fetchMarketplaceServices } from "@/lib/marketplace/queries";
import { useT } from "@/i18n";

export const Route = createFileRoute("/marketplace/category/$slug")({
  head: () => ({
    meta: [
      { title: "Category | BeHot.Now Marketplace" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: CategoryPage,
});

function CategoryPage() {
  const { t } = useT();
  const { slug } = Route.useParams();
  const { data: categories } = useQuery({ queryKey: ["mp-categories"], queryFn: fetchMarketplaceCategories });
  const category = (categories ?? []).find((c) => c.slug === slug);

  const { data: services, isLoading } = useQuery({
    queryKey: ["mp-category", category?.id],
    enabled: Boolean(category?.id),
    queryFn: () => fetchMarketplaceServices({ categoryId: category!.id, sort: "hot", limit: 48 }),
  });

  return (
    <MarketplaceGate>
      <div className="mx-auto max-w-6xl px-4 py-8">
        <h1 className="font-display text-3xl font-bold">{category?.name ?? t("mp.category.fallback_title")}</h1>
        {category?.description && <p className="mt-2 text-sm text-muted-foreground">{category.description}</p>}
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {(services ?? []).map((s) => (
            <MarketplaceServiceCard key={s.id} service={s} promoted={isFeatured(s.featured_until)} />
          ))}
        </div>
        {!isLoading && !services?.length && (
          <p className="mt-10 text-center text-sm text-muted-foreground">{t("mp.category.empty")}</p>
        )}
      </div>
    </MarketplaceGate>
  );
}
